import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
export function HeroBackground() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (!canvasRef.current) return;
    // Scene setup
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 30;
    const renderer = new THREE.WebGLRenderer({
      canvas: canvasRef.current,
      alpha: true,
      antialias: true
    });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    // Colors from the design
    const colors = [0x31192e, 0x4a2d47, 0x6d5a5e, 0x8b7355, 0xd4af71 // Gold
    ];
    // Create shapes
    const shapes: THREE.Mesh[] = [];
    const shapeCount = 45;
    for (let i = 0; i < shapeCount; i++) {
      let geometry;
      const shapeType = Math.floor(Math.random() * 3);
      // Create different shapes
      if (shapeType === 0) {
        // Box (square)
        const size = Math.random() * 3.375 + 0.84375;
        geometry = new THREE.BoxGeometry(size, size, size);
      } else if (shapeType === 1) {
        // Sphere (circle)
        const radius = Math.random() * 1.6875 + 0.50625;
        geometry = new THREE.SphereGeometry(radius, 32, 32);
      } else {
        // Tetrahedron (triangle)
        const size = Math.random() * 2.53125 + 0.84375;
        geometry = new THREE.TetrahedronGeometry(size);
      }
      const material = new THREE.MeshPhongMaterial({
        color: colors[Math.floor(Math.random() * colors.length)],
        transparent: true,
        opacity: 0.3 + Math.random() * 0.3,
        shininess: 30
      });
      const mesh = new THREE.Mesh(geometry, material);
      // Position shapes evenly across left and right
      mesh.position.x = Math.random() * 60 - 30;
      mesh.position.y = Math.random() * 40 - 20;
      mesh.position.z = Math.random() * 20 - 10;
      // Random rotation
      mesh.rotation.x = Math.random() * Math.PI;
      mesh.rotation.y = Math.random() * Math.PI;
      // Determine if this shape should be faster (50% chance)
      const isFaster = Math.random() < 0.5;
      const speedMultiplier = isFaster ? 1.5 : 1;
      // Store animation properties
      mesh.userData = {
        speedX: (Math.random() - 0.5) * 0.005 * speedMultiplier,
        speedY: (Math.random() - 0.5) * 0.005 * speedMultiplier,
        rotationSpeed: (Math.random() - 0.5) * 0.005 * speedMultiplier,
        initialX: mesh.position.x,
        initialY: mesh.position.y
      };
      shapes.push(mesh);
      scene.add(mesh);
    }
    // Lighting
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.4);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);
    // Animation
    let animationFrameId: number;
    const animate = () => {
      animationFrameId = requestAnimationFrame(animate);
      shapes.forEach(shape => {
        // Gentle floating animation
        shape.position.x += shape.userData.speedX;
        shape.position.y += shape.userData.speedY;
        // Rotate shapes
        shape.rotation.x += shape.userData.rotationSpeed;
        shape.rotation.y += shape.userData.rotationSpeed;
        // Boundary check and reset
        if (Math.abs(shape.position.x - shape.userData.initialX) > 5) {
          shape.userData.speedX *= -1;
        }
        if (Math.abs(shape.position.y - shape.userData.initialY) > 5) {
          shape.userData.speedY *= -1;
        }
      });
      renderer.render(scene, camera);
    };
    animate();
    // Handle resize
    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
      shapes.forEach(shape => {
        shape.geometry.dispose();
        if (Array.isArray(shape.material)) {
          shape.material.forEach(mat => mat.dispose());
        } else {
          shape.material.dispose();
        }
      });
      renderer.dispose();
    };
  }, []);
  return <canvas ref={canvasRef} className="absolute inset-0 pointer-events-none" style={{
    opacity: 0.6,
    maskImage: 'linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 85%, rgba(0,0,0,0) 100%)',
    WebkitMaskImage: 'linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 85%, rgba(0,0,0,0) 100%)'
  }} data-id="element-67" />;
}